import React, { Fragment } from "react"
import TypeAnimation from "react-type-animation"
import "./index.css"
import bgVideo from "../assets/landingbg.mp4"
import mobileBg from "../assets/mobilebg.mp4"
import "./video.css"

import Layout from "../components/layout"
import LandingMiddleSection from "../components/landingMiddleSection"
import LandingNewsSection from "../components/landingNewsSection"
import LandingPartnerSection from "../components/landingPartnerSections"
import LogoOutline from "../images/logooutline.svg"
import LandingAboutUs from "../components/landingAboutUs"
const IndexPage = () => (
  <Layout>
    <div className="  h-screen  w-full flex flex-col  relative  ">
      <video
        autoPlay
        muted
        loop
        className="  flex md:hidden   object-cover    h-full    "
      >
        <source src={mobileBg} className="" type="video/mp4" />
      </video>
      <video
        autoPlay
        muted
        loop
        className="  hidden md:flex   object-cover    h-full    "
      >
        <source src={bgVideo} className="" type="video/mp4" />
      </video>
      <div className=" absolute top-6 md:top-32 right-10 md:right-32">
        <img
          src={LogoOutline}
          className="animate-pulse w-60 md:w-full max-w-4xl"
          alt=""
        />
        <span className=" text-2xl md:text-5xl   text-gray-50 break-words font-body   ">
          <TypeAnimation
            cursor={true}
            sequence={[
              "Multiverse of cyber ranges",
              3000,
              "We innovate cyber",
              3000,
            ]}
            wrapper="div"
            repeat={3}
          />
        </span>
      </div>
    </div>
    <LandingAboutUs />

    <LandingMiddleSection />
    <LandingNewsSection />
    <LandingPartnerSection />
  </Layout>
)

export default IndexPage

{
  /* <div className="relative ">
<main className="lg:relative">
  <div className="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
    <div className="  max-w-full md:max-w-md w-full  ">
      <span className=" text-7xl font-bold text-cyan-600 break-words font-body   ">
        <TypeAnimation
          cursor={true}
          sequence={[
            "Multiverse of cyber ranges",
            3000,
            "New text for here needed",
            3000,
          ]}
          wrapper="div"
          repeat={3}
        />
      </span>
    </div>
  </div>
  <div className="relative max-w-7xl w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
    <div className=" h-full p-4  ">
      <video
        autoPlay
        muted
        loop
        className=" rounded-xl   object-cover h-full "
      >
        <source src={bgVideo} type="video/mp4" />
      </video>
    </div>
  </div>
</main>
</div> */
}
